import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { PAGE_TREE_STATUSES } from '@confluence/page-tree/entry-points/pageTreeStatuses.ts';
import { preloadPageTree } from '@confluence/page-tree/entry-points/preloadPageTree.ts';

import EmbedContainerQuery, {
	type EmbedContainerQuery$data,
	type EmbedContainerQuery$variables,
} from './__generated__/EmbedContainerQuery.graphql.ts';

export async function preloadEmbedData(spaceKey: string, contentId: string): Promise<any> {
	return waitForAllReturnWhenError([
		preloadContentData(contentId, spaceKey),
		preloadContentTree(contentId, spaceKey),
	]);
}

async function preloadContentData(contentId: string, spaceKey: string): Promise<void> {
	await query<EmbedContainerQuery$data, EmbedContainerQuery$variables>({
		query: EmbedContainerQuery,
		variables: {
			contentId,
			spaceKey,
		},
	});
}

async function preloadContentTree(contentId: string, spaceKey: string): Promise<void> {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR && contentId) {
		await preloadPageTree({
			spaceKey,
			statuses: PAGE_TREE_STATUSES,
			isSuperAdmin: false,
			contentId,
		});
	}
}
